var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361,
    height: 240,
    viewBox: "0 0 361 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1497_19772)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 361,
    transform: "matrix(0 -1 1 0 0 240)",
    fill: "url(#paint0_linear_1497_19772)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1497_19772",
    x1: 9.92606,
    y1: 361.003,
    x2: 221.867,
    y2: 361.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D0B03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#902300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A4400"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1497_19772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 361,
    fill: "white",
    transform: "matrix(0 -1 1 0 0 240)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgGradient);
export default __webpack_public_path__ + "static/media/bg-gradient.7ea57f104e90c6707f5a62a022ae8faf.svg";
export { ForwardRef as ReactComponent };